// extracted by mini-css-extract-plugin
export var deleteModal = "_r5-0";